import { Tag } from 'antd';

import Button from '~/shared/components/form-fields/button';
import Link from '~/shared/components/link';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import { getDate, getUrl } from '~/shared/helpers/string-helpers';
import type { ItemDataType } from '~/shared/types/general-type';
import type { I18nextOptionsType } from '~/shared/types/i18n-type';
import type { TagType } from '~/shared/types/tag-type';

import '~/shared/components/items-navigator/components/extended-row-item/extended-row-item.scss';

import noImage from '~/assets/no-image.webp';

type ExtendedRowItemPropsType = {
  data: ItemDataType;
  pageToGo: string;
  pageTagsToGo?: string;
  t: (key: string, options: I18nextOptionsType) => string;
};

const ExtendedRowItem = ({ data, lng, pageToGo, pageTagsToGo, t }: ExtendedRowItemPropsType) => (
  <article itemProp="blogPosts" itemScope itemType="http://schema.org/BlogPosting" className="extended-row-item">
    <link itemProp="image" href={data?.thumbnail?.path ?? noImage.src} />
    <div
      className="extended-row-item__image"
      style={{
        background: `url(${data?.thumbnail?.path ?? noImage.src}) center/cover no-repeat`,
      }}
    />
    <div className="extended-row-item__content">
      <div className="extended-row-item__title">
        <Link itemProp="url" href={getLocaleLink(getUrl({ link: pageToGo, alias: data?.alias }), lng)}>
          <span itemProp="headline">{data?.title}</span>
        </Link>
      </div>
      <div className="extended-row-item__content-inner-wrapper">
        {data?.createdAt && (
          <p className="extended-row-item__date">
            <time itemProp="datePublished" dateTime={data?.createdAt}>
              {getDate(data?.createdAt, 'DATE')}
            </time>
          </p>
        )}
        <p
          itemProp="description"
          className="extended-row-item__text"
          suppressHydrationWarning
          dangerouslySetInnerHTML={{ __html: data?.description }}
        />
        <p className="extended-row-item__tags">
          {(data?.tags ?? []).map((tag: TagType) => (
            <Link
              itemProp="url"
              key={tag?.alias}
              href={getLocaleLink(getUrl({ link: pageToGo, alias: data?.alias }), lng)}
            >
              <Tag key={tag?.alias}>{tag?.name}</Tag>
            </Link>
          ))}
        </p>
        <Button className="link small" href={getLocaleLink(getUrl({ link: pageToGo, alias: data?.alias }), lng)}>
          {t('button.more')}
        </Button>
      </div>
    </div>
  </article>
);
export default ExtendedRowItem;
